import { useHoverCardStore } from './hoverCardStore';
import { EntityCard } from '@/components/ui/EntityCard';
import { HoverCard } from '@/components/ui/HoverCard';
import { useFacetOptionDetails } from '@/hooks/filters/useFacetOptionDetails';
import { buildHoverCardFields } from '@/lib/resource-config';
import type { FacetConfig } from '@/lib/resource-config/types';

interface FacetOptionHoverCardLayerProps {
  facetConfig: FacetConfig;
}

export const FacetOptionHoverCardLayer = ({
  facetConfig,
}: FacetOptionHoverCardLayerProps) => {
  const { anchorEl, optionId, clear } = useHoverCardStore();

  const hoverCardEnabled = Boolean(
    facetConfig?.hoverCard && facetConfig.valueSource.kind === 'collection',
  );

  const { data, isLoading, isError } = useFacetOptionDetails({
    facetConfig,
    entityId: optionId,
    enabled: hoverCardEnabled && !!optionId,
  });

  if (!hoverCardEnabled) return null;

  return (
    <HoverCard
      anchorEl={anchorEl}
      onKeepOpen={() => useHoverCardStore.getState().cancelClear()}
      onClose={() => clear()}
      onExited={() => {
        if (!useHoverCardStore.getState().anchorEl) {
          useHoverCardStore.getState().clearOptionId();
        }
      }}
    >
      <EntityCard
        id={optionId!}
        type={facetConfig.hoverCard?.type}
        loading={isLoading}
        error={isError || (!isLoading && !data)}
        fields={
          facetConfig.hoverCard
            ? buildHoverCardFields(facetConfig.hoverCard, data)
            : undefined
        }
      />
    </HoverCard>
  );
};
